<template>
  <div class="ring"></div>
</template>

<script>
export default {
  name: "",
  props: ["data"],
  data() {
    return {
      ringData: [
        [{ value: 2, name: "Search Eng2ine" }],
        [
          { value: 1, name: "Search Eng2ine1" },
          { value: 2, name: "Search Engine2" },
          { value: 3, name: "Search Engine3" },
        ],
        [
          { value: 3, name: "Search Eng2ine" },
          { value: 2, name: "Search Engine2" },
          { value: 1, name: "Search Engine2" },
        ],
      ],
    };
  },
  methods: {
    setChart() {
      const obj = {
        type: "pie",
        avoidLabelOverlap: false,
        tooltip: {
          confine: true,
          trigger: "item",
        },
        color: [
          "rgba(89, 207, 122, 1)",
          "rgba(228, 204, 16, 1)",
          "rgba(225, 106, 106, 1)",
        ],
        label: {
          show: false,
          position: "center",
          //   formatter: ({ value }) => {
          //     return "{title|核心风险}" + "\n" + `{detail|${value}}`;
          //   },
          //   rich: {
          //     title: {
          //       color: "rgba(255, 255, 255, 1)",
          //     },
          //     detail: {
          //       color: "rgba(255, 255, 255, 1)",
          //     },
          //   },
        },
        labelLine: {
          normal: {
            show: false,
          },
        },
      };
      let data2 = [];
      let data1 = [];
      let data0 = [];
      this.data.slice(0, 3).forEach((item2, index) => {
        item2.forEach((item) => {
          if (item.value > 0) {
            if (index == 2) {
              data2 = this.data[2].filter((item3) => item3.name);
            }
            if (index == 1) {
              data1 = this.data[1].filter((item3) => item3.name);
            }
            if (index == 0) {
              data0 = this.data[0].filter((item3) => item3.name);
            }
          }
        });
      });
      const option = {
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            ...obj,
            radius: ["80%", "90%"],
            data: data2,
          },
          {
            ...obj,
            radius: ["60%", "70%"],
            data: data1,
          },
          {
            ...obj,
            radius: ["40%", "50%"],
            data: data0,
          },
        ],
      };
      let myChart = this.$echarts(this.$el);
      myChart.clear();
      myChart.resize();
      myChart.setOption(option);
    },
  },
  mounted() {
    this.setChart();
  },
};
</script>

<style lang="less" scoped>
.ring {
  width: 100%;
  height: 100%;
}
</style>
